import { TextSkeleton } from '@/components/skeleton/TextSkeleton'
import { Avatar } from 'containers/recommendations/Avatar'

export const ConnectionCardSkeleton = () => {
  return (
    <div className="full-w bg-white-primary p-16 rounded-16">
      <div className="flex justify-space-between items-center">
        <div className="flex items-center gap-12">
          <div>
            <Avatar isLoading={true} size={48} image="" />
          </div>
          <div className="flex flex-column gap-6">
            <TextSkeleton width={150} height={15} />
            <TextSkeleton width={100} height={12} />
            <div className="flex gap-6">
              <TextSkeleton width={16} height={12} />
              <TextSkeleton width={100} height={12} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
